import { each } from "lodash";

declare const jQuery: any;
const $ = jQuery;

const ajaxCall: Function = window["iw"].utils.ajaxCall;

const FETCH_FROM_WP = false; // WP fetch is very slow; fetching direct requires an env var
const ENABLED = window["iw"].solrSuggestEnabled;

export type SuggestionSelectHandler = (suggestion?: string) => void;

export function initSearchSuggestionInput($wrap, $input, onSelectSuggestion?: Function): void {
    if (!ENABLED) {
        return;
    }

    const $suggWrap = $(`<div class="suggestions">`).appendTo($wrap);

    let suggestionIndex = -1;

    const highlightCurrentSuggestion = () => {
        const $suggestions = $suggWrap.children().removeClass("selected");
        if (suggestionIndex >= 0) {
            $suggestions.eq(suggestionIndex).addClass("selected");
        }
    };

    const selectSuggestion = (suggestion: string) => {
        $input.val(suggestion);
        $suggWrap.addClass("hide");
        if (onSelectSuggestion) {
            onSelectSuggestion(suggestion);
        }
    };

    const getSelectedSuggestion = (): string|undefined => {
        if (suggestionIndex >= 0) {
            return $.trim($suggWrap.children().eq(suggestionIndex).text() || "") || undefined;
        }
        return undefined;
    };

    const getNumSuggestions = (): number => $suggWrap.children().length;

    let prevInputValue: string = "";
    
    $input.on("input", async function (event): Promise<void> {
        suggestionIndex = -1;
        const query: string = prevInputValue = $.trim($input.val() || "");
        if (!query) {
            $suggWrap.addClass("hide").empty();
            return;
        }
        const suggestions: string[] = await fetchSuggestions(query);
        if (suggestions.length === 0) {
            $suggWrap.addClass("hide").empty();
            return;
        }
        $suggWrap.empty().removeClass("hide");
        each(suggestions, (suggestion: string) => {
            $(`<div class="suggestion">`).text(suggestion).on("click", function (event) {
                selectSuggestion(suggestion);
                return false;
            }).appendTo($suggWrap);
        });
    }).on("focus", function (event) {
        if (getNumSuggestions()) {
            $suggWrap.removeClass("hide");
        }
    }).on("click", function (event) {
        event.stopPropagation();
    });

    $suggWrap.on("click", function (event) {
        event.stopPropagation();
    });

    $wrap.on("keydown", function (event) {
        const code: string = event.originalEvent.code;
        switch (code) {
            case "ArrowDown":
                const finalIndex: number = getNumSuggestions() - 1;
                if (suggestionIndex >= finalIndex) {
                    suggestionIndex = finalIndex;
                } else {
                    ++suggestionIndex;
                }
                highlightCurrentSuggestion();
                $input.val(getSelectedSuggestion());
                break;
            case "ArrowUp":
                if (suggestionIndex <= 0) {
                    suggestionIndex = -1;
                    $input.val(prevInputValue || "");
                    highlightCurrentSuggestion(); // clear suggestion highlight
                    break;
                }
                --suggestionIndex;
                highlightCurrentSuggestion();
                $input.val(getSelectedSuggestion());
                break;
            case "Escape":
                if (prevInputValue) {
                    $input.val(prevInputValue);
                }
                $suggWrap.addClass("hide");
                suggestionIndex = -1;
                break;
        }
    });

    // click off to close autosuggestions
    const hide = (): void => {
        $suggWrap.addClass("hide");
    };
    $(document.body).on("click", hide);
}

export function initSearchSuggestions(): void {
    if (!ENABLED) {
        return;
    }
    initPopupSearchSuggestion();
    const $wraps = $(`[data-suggest-wrap]`);
    if ($wraps.length === 0) {
        return;
    }
    $wraps.each(function () {
        const $wrap = $(this);
        const $input = $wrap.find(`[data-suggest-input]`);
        if ($input.length === 0) {
            return;
        }
        const $form = $input.closest("form");
        if ($form.length === 0) {
            return;
        }
        initSearchSuggestionInput($wrap, $input, (suggestion: string): void => {
            if ($.trim($input.val())) {
                $form.trigger("submit");
            }
        });
    });
}

function initPopupSearchSuggestion(): void {
    const $wrap = $(`.popup-search .popup-input-wrap`);
    if ($wrap.length === 0) {
        return;
    }

    const $input = $wrap.find(`input.popup-search-text`);
    if ($input.length === 0) {
        return;
    }

    const $form = $input.closest("form");
    if ($form.length === 0) {
        return;
    }

    $input.attr({ autocomplete: "off" });

    initSearchSuggestionInput($wrap, $input, (suggestion: string): void => {
        $form.trigger("submit");
    });
}

const suggestionCache: any = {}; // query strings mapped to suggestions (string[])

async function fetchSuggestions(query: string): Promise<string[]> {
    if (suggestionCache[query]) {
        return suggestionCache[query];
    }
    const fetchFromWp = FETCH_FROM_WP || !window.fetch;
    try {
        let suggestions: string[];
        if (fetchFromWp) {
            suggestions = await fetchSuggestionsFromWp(query);
        } else {
            suggestions = await fetchSuggestionsDirect(query);
        }
        suggestionCache[query] = suggestions || [];
        return suggestions;
    }
    catch (error) {
        console.error("fetchSuggestions failed", error);
        suggestionCache[query] = [];
        return [];
    }
}

async function fetchSuggestionsFromWp(query: string): Promise<string[]> {
    
    const response = await ajaxCall("hs_solr_suggest", { q: query });
    return response?.suggestions || [];
}

async function fetchSuggestionsDirect(query: string): Promise<string[]> {
    const url: string = `/wp-content/themes/iwdtheme2-child/suggest.php?q=${encodeURIComponent(query)}`;
    const response: Response = await window.fetch(url);
    const data = await response.json();
    return data?.suggestions || [];
}
